export default __webpack_public_path__ + "41b9b9e4d1e3d7536ce44498bc8837d5.png";